<div class="video-component overflow-hidden"
     [ngClass]="[component?.ratio || '']">
    <local-shell />
    <!-- image -->
    <ng-container *ngIf="component?.background_image">
        <img class="z-1"
             [class.rf]="!!component?.ratio"
             [image]="component?.background_image">
    </ng-container>

    <ng-container *ngIf="component?.video_id && !component?.video_hide">
        <youtube-player class="z-2"
                        [class.rf]="!!component?.ratio"
                        [video-id]="component?.video_id"
                        [autoplay-in-viewport]="component?.video_autoplay"
                        [background]="component?.video_background"
                        *ngIf="component?.video_provider === 'youtube'">
            <ng-template #playButton>
                <i class="icon-play"></i>
            </ng-template>

            <ng-template #pauseButton>
                <i class="icon-pause"></i>
            </ng-template>
        </youtube-player>

        <vimeo-player class="z-2"
                      [class.rf]="!!component?.ratio"
                      [video-id]="component?.video_id"
                      [autoplay-in-viewport]="component.video_autoplay"
                      [background]="component.video_background"
                      *ngIf="component?.video_provider === 'vimeo'">
            <!-- play icon -->
            <ng-template #playButton>
                <i class="icon-play"></i>
            </ng-template>

            <!-- pause icon -->
            <ng-template #pauseButton>
                <i class="icon-pause"></i>
            </ng-template>
        </vimeo-player>
    </ng-container>
</div>
